<template>
  <div style="margin-top: 20px;">
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
      <el-form-item label="链接名称" prop="linkName">
        <el-input
            v-model="queryParams.linkName"
            placeholder="请输入链接名称"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="链接地址" prop="linkAddress">
        <el-input
            v-model="queryParams.linkAddress"
            placeholder="请输入链接地址"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
    </el-row>

    <el-table v-loading="loading" :data="cccmbOldList">
      <el-table-column type="index" width="55" align="center" label="序号"/>
      <el-table-column label="链接名称" align="center" prop="linkName" />
      <el-table-column label="链接地址" align="center" prop="linkAddress	">
        <template slot-scope="scope">
          <span style="cursor: pointer;color: #4A8DEC" @click="goLink(scope.row.linkAddress	)">{{scope.row.linkAddress	}}</span>
        </template>
      </el-table-column>
    </el-table>

    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
    />

  </div>
</template>

<script>
import {
  listKsyyOld,
} from "@/api/ymtapi/ksyyOld";
import {parseTime} from "../../utils/yawei";

export default {
  name: "ppjslink",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      // 特种设备预约管理表格数据
      cccmbOldList: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        linkName: undefined,
        linkAddress: undefined,
        pubStatus: undefined,
        linkType: undefined
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    parseTime,
    /** 查询特种设备预约管理列表 */
    getList() {
      this.loading = true;
      listKsyyOld(this.queryParams).then(response => {
        this.cccmbOldList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    goLink(link){
      window.open(link)
    }
  }
};
</script>
